"use client";

import Script from "next/script";
import { useEffect } from "react";

// Flodesk email signup (embed + header code from the website Figma). The
// "universal" loader defines window.fd (a queue stub until the real script
// loads); we then call fd('form', …) to mount the form into its container.
// Co-located here (not the root layout) so Flodesk only loads where the footer
// renders — i.e. customer pages, never the staff console.
const FLODESK_FORM_ID = "6838e7b4f074f435ff2d3857";

export function FlodeskSignup() {
  useEffect(() => {
    let tries = 0;
    const init = () => {
      const w = window as unknown as { fd?: (...args: unknown[]) => void };
      if (typeof w.fd === "function") {
        w.fd("form", { formId: FLODESK_FORM_ID, containerEl: `#fd-form-${FLODESK_FORM_ID}` });
        return true;
      }
      return false;
    };
    if (init()) return;
    // The universal loader runs afterInteractive — retry briefly until fd exists.
    const id = setInterval(() => {
      if (init() || ++tries > 50) clearInterval(id);
    }, 100);
    return () => clearInterval(id);
  }, []);

  return (
    <>
      <Script id="flodesk-universal" strategy="afterInteractive">
        {`(function(w, d, t, h, s, n) {
  w.FlodeskObject = n;
  var fn = function() { (w[n].q = w[n].q || []).push(arguments); };
  w[n] = w[n] || fn;
  var f = d.getElementsByTagName(t)[0];
  var v = '?v=' + Math.floor(new Date().getTime() / (120 * 1000)) * 60;
  var sm = d.createElement(t); sm.async = true; sm.type = 'module';
  sm.src = h + s + '.mjs' + v; f.parentNode.insertBefore(sm, f);
  var sn = d.createElement(t); sn.async = true; sn.noModule = true;
  sn.src = h + s + '.js' + v; f.parentNode.insertBefore(sn, f);
})(window, document, 'script', 'https://assets.flodesk.com', '/universal', 'fd');`}
      </Script>
      <div id={`fd-form-${FLODESK_FORM_ID}`} />
    </>
  );
}
